import { PaymentProvider } from './payment-provider';
import { VuPaymentType } from './vu-payment-type.enum';

export class VuPaymentProvider extends PaymentProvider {
  private _paymentType: VuPaymentType;

  constructor(
    id: number,
    name: string,
    paymentType: VuPaymentType,
  ) {
    super(id, name, null, true);
    this._paymentType = paymentType;
  }

  get paymentType(): VuPaymentType {
    return this._paymentType;
  }
}
